'use client';
import { jsx } from 'react/jsx-runtime';
import { removeCoreProps } from '../core/core.utils.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { SwanComboboxContextProvider } from './combobox.context.js';
import { FlexBox } from '../flex-box/flex-box.component.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const Combobox = renderWithRef('Combobox', null, (n, l)=>{
    useComponentStylesLoaded('Combobox', [
        SWAN_STYLE_KEY_MAP.listbox,
        SWAN_STYLE_KEY_MAP.popover
    ]);
    let { children: m, items: a, menuTrigger: u } = n, f = _object_without_properties(n, [
        "children",
        "items",
        "menuTrigger"
    ]);
    return jsx(FlexBox, {
        className: className(n.className, ...processStyleProps(f), 'swan-combobox-container', {
            'swan-combobox-container-with-focus-trigger': 'focus' === u
        }),
        ref: l,
        children: jsx(CollectionContextProvider, {
            items: a,
            children: jsx(SwanComboboxContextProvider, _object_spread_props(_object_spread({}, removeCoreProps(n)), {
                children: m
            }))
        })
    });
});

export { Combobox };
